import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import "../../_shark_models/Picture";

class PictureManager extends Controller {
	constructor () {
		super("pictureManager");
	}





	
	delete (picture) {
		const rd = NousCore.api.createRequest({ item: picture.export() });

		NousCore.api.send("picture/delete", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const pictureList = Shark.get("pictureList");

						if (pictureList) {
							const pictureIndex = Utils.safp(pictureList, "guid", picture.guid, "index");

							if (pictureIndex > -1) {
								pictureList.splice(pictureIndex, 1);
							}
						}

						pictureManager.emit("deleted");
						pictureManager.emit("listChanged");
						break;
					case 404:
						pictureManager.emit("deleteError");
						break;
				}
			}
		});
	}

	getList (parentGallery) {
		if (!parentGallery || parentGallery.guid === "") {
			Shark.trace("Non ho un gallery guid, non proseguo", Shark.TRACE_LOG);
			return;
		}

		const data = { item: { galleryGuid: parentGallery.guid } };
		const rd = NousCore.api.createRequest(data);

		NousCore.api.send("picture/get-list", rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const pictureList = Shark.getInstanceList("Picture", data.items);

						pictureList.sort((a, b) => {
							if (a.name > b.name) {
								return 1;
							}
							else if (a.name < b.name) {
								return -1;
							}
						});

						Shark.set("pictureList", pictureList);

						pictureManager.emit("listChanged");
						break;
					case 404:
						pictureManager.emit("listGetError");
						break;
				}
			}
		});
	}

	save (picture) {
		const rd = NousCore.api.createRequest({ item: picture.export() });
		const action = picture.guid === "" ? "insert" : "update";

		NousCore.api.send(`picture/${action}`, rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						picture.import(data.items[0]);
						picture.clean();

						let pictureList = Shark.get("pictureList");

						if (!pictureList) {
							pictureList = [];
							Shark.set("pictureList", pictureList);
						}
						if (action === "insert") {
							pictureList.push(picture);
						}

						pictureManager.emit("saved");
						pictureManager.emit("listChanged");
						break;
					case 99:
						pictureManager.emit("saveError");
						break;
				}
			}
		});
	}
}

const pictureManager = new PictureManager();

Shark.registerController(pictureManager);

export { pictureManager };
